// extracted by mini-css-extract-plugin
export default {"chartCard":"index_chartCard__zTfXl","chartCardTitle":"index_chartCardTitle__lafbR","chartCardContent":"index_chartCardContent__3T+5b"};